import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import moment from "moment";
import includes from "lodash/includes";

import { Header, List } from "../../../shared/GridComponents";
import Item from "./Item";
// import List from "./List";

import FilterOptions from "./FilterOptions";
import formWrapper from "../../../shared/Form";
import GetItem from "../../../../helpers/dataProviders/getItem";

class NotificationsUI extends Component {
	constructor(props) {
		super(props);
		this.url = props.match.url;
		this.push = props.history.push;
	}

	componentDidMount() {
		const { formApi, appKey } = this.props;
		const _values = localStorage.getItem(`notificationsFiltering-${appKey}`);
		const values = _values ? JSON.parse(_values) : {};
		if (formApi) formApi.setValues(values);
	}

	componentDidUpdate(prevProps) {
		const { values, appKey } = this.props;
		if (prevProps.values !== values) {
			localStorage.setItem(`notificationsFiltering-${appKey}`, JSON.stringify(values));
		}
	}

	deleteItem = (id, name) => {
		this.props.delete(id, name);
	};

	createItem = () => {
		this.push(`${this.url}/new`);
	};

	duplicateItem = id => {
		this.push(`${this.url}/copy/${id}`);
	};

	editItem = id => {
		this.push(`${this.url}/${id}`);
	};

	sendNow = id => {
		const { update } = this.props;
		GetItem(`/notifications/${id}`).then(res => {
			const { data } = res;
			const { topics } = data;
			let topicsToSend = [];
			if (topics) {
				topicsToSend = topics.map(topic => topic.id);
			}
			const values = {
				...data,
				topics: topicsToSend,
				sendAt: new Date(moment.utc().toISOString()),
			};
			delete values.sendAtLocal;
			delete values.isSent;
			update(values, null, id);
		});
	};

	isError = (isSent, sendAt) => {
		const isPast = moment(sendAt).isBefore(moment().add(-3, "minutes"));
		return isPast && !isSent;
	};

	getStatus = (isSent, isError) => {
		if (isError) {
			return "ERROR";
		} else if (isSent) {
			return "SENT";
		} else {
			return "PENDING";
		}
	};

	filterItemByStatus = (item, status) => {
		let statusToFilter = [];
		if (!status || status === "ALL") {
			statusToFilter = true;
		} else if (status) {
			statusToFilter = status ? status === item.status : true;
		}
		return statusToFilter;
	};

	filterItemByDate = (item, startDate, endDate) => {
		const { sendAt } = item;
		const afterStart = startDate ? moment(sendAt).isAfter(moment(startDate)) : true;
		const beforeEnd = endDate ? moment(sendAt).isBefore(moment(endDate)) : true;
		return afterStart && beforeEnd;
	};

	filterItemByTopic = (item, topics) => {
		if (topics && item.topics) {
			const topicIds = item.topics.map(i => i.id);
			return topics.every(t => includes(topicIds, t));
		} else if (!topics) {
			return true;
		}
	};

	filter = items => {
		const { values } = this.props;
		const { status, startDate, endDate, topics } = values;
		return items.filter(
			item =>
				this.filterItemByStatus(item, status) &&
				this.filterItemByDate(item, startDate, endDate) &&
				this.filterItemByTopic(item, topics)
		);
	};

	render() {
		const { items } = this.props;

		const CRUD = {
			deleteItem: this.deleteItem,
			duplicateItem: this.duplicateItem,
			editItem: this.editItem,
			sendNow: this.sendNow,
		};

		const itemsList = items.map(item => {
			const { isSent, sendAt } = item;
			const isError = this.isError(isSent, sendAt);
			const status = this.getStatus(isSent, isError);
			return {
				...item,
				status: status,
			};
		});

		const itemsToDisplay = this.filter(itemsList);

		let defaultText = "Create your first notification";

		if (items && itemsToDisplay.length === 0) {
			defaultText = "There are no items that match your search criteria.";
		}

		return (
			<div>
				<Header pluralItemName="notifications" createItem={this.createItem} />
				<FilterOptions />
				<List
					defaultText={defaultText}
					items={itemsToDisplay}
					renderItem={({ item }) => <Item item={item} crud={CRUD} />}
				/>
			</div>
		);
	}
}

NotificationsUI.propTypes = {
	items: PropTypes.array.isRequired,
	match: PropTypes.object.isRequired,
	history: PropTypes.object.isRequired,
	delete: PropTypes.func.isRequired,
	update: PropTypes.func,
	singleItemName: PropTypes.string,
	values: PropTypes.object.isRequired,
	formApi: PropTypes.object.isRequired,
	appKey: PropTypes.string.isRequired,
};

export default withRouter(formWrapper(NotificationsUI, false));
